import बोलीवियाFlag from "@/assets/flags/bo.svg";
import ब्राज़िलFlag from "@/assets/flags/br.svg";
import कोलंबियाFlag from "@/assets/flags/co.svg";
import इक्वाडोरFlag from "@/assets/flags/ec.svg";
import गुयानाFlag from "@/assets/flags/gy.svg";
import पेरूFlag from "@/assets/flags/pe.svg";
import सूरीनामFlag from "@/assets/flags/sr.svg";
import वेनेजुएलाFlag from "@/assets/flags/ve.svg";
import logoPT from "@/assets/toolbox/PBA PT.png";
import logoEN from "@/assets/toolbox/PBA EN.png";
import logoES from "@/assets/toolbox/PBA ES.png";

export default {
  name: "HeaderComponent",
  components: {},
  data() {
    return {
      flags: [
        { src: बोलीवियाFlag, alt: "Bolívia" },
        { src: ब्राज़िलFlag, alt: "Brasil" },
        { src: कोलंबियाFlag, alt: "Colômbia" },
        { src: इक्वाडोरFlag, alt: "Equador" },
        { src: गुयानाFlag, alt: "Guiana" },
        { src: पेरूFlag, alt: "Peru" },
        { src: सूरीनामFlag, alt: "Suriname" },
        { src: वेनेजुएलाFlag, alt: "Venezuela" },
      ],
    };
  },
  computed: {
    logoProjeto() {
      const locale = this.$i18n.locale;
      if (locale === 'pt') {
        return logoPT;
      } else if (locale === 'es') {
        return logoES;
      }
      return logoEN;
    }
  },
  methods: {
    setLocale(locale) {
      this.$i18n.locale = locale;
      localStorage.setItem('userLanguage', locale);
    },
  },
};
